import React, { useEffect, useRef, useState } from 'react'

import img from 'assets/images/distributionPage/Partners/stage-4-2.png'
import video from 'assets/images/distributionPage/Partners/stage4.mp4'
import classNames from 'classnames'
import { useDistributionContext } from 'pages/Distribution/Distribution'
import { Button, Video } from 'shared/components'
import { useIntersection, useWindowSize } from 'shared/hooks'
import { delay, playVideo } from 'shared/utils'
import { detectDevice } from 'shared/utils/detectDevice'

import classes from './HowItWork.module.scss'
import { howItWorkItems } from './items'

export const HowItWork = (): JSX.Element => {
  const ref = useRef<HTMLVideoElement>(null)
  const itemsRef = useRef<HTMLDivElement[]>([])
  const btnRef = useRef<HTMLDivElement>(null)

  const [containerRef, entry] = useIntersection({ threshold: 0.8 })
  const [isPlay, setIsPlay] = useState(false)

  const { setPartnerFormOpened } = useDistributionContext()
  const isTablet = detectDevice()
  const { isMobile } = useWindowSize()

  useEffect(() => {
    if (entry.isIntersecting && !isPlay) {
      setIsPlay(true)
      playVideo(ref.current)
      const lastIndex = itemsRef.current.length - 1
      if (!isTablet && !isMobile) {
        itemsRef.current.forEach((el, elIndex) => {
          delay(() => {
            el.classList.add('is-revealed')

            //Если элемент последний, то анимируем кнопку
            if (elIndex === lastIndex) {
              delay(() => btnRef.current?.classList.add('is-revealed'), 1000)
            }
          }, getNumber(elIndex))
        })
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [entry.isIntersecting])

  const getNumber = (index: number) => {
    if (!isTablet && !isMobile) {
      return index === 1 ? 3500 : 3100 * index
    }

    return index * 100
  }

  const renderTablet = () => <img className={classes.img} src={img} alt="" />
  const className = classNames([
    classes.video_container,
    'col-xs-12 col-sm-12 col-md-2 col-lg-5',
    {
      [classes.offset]: isTablet,
    },
  ])

  return (
    <div className={`${classes.container} container`}>
      <div className="row">
        <div className={className}>
          <Video
            videoRef={ref}
            className={classes.video}
            src={video}
            childTablet={renderTablet}
          />
        </div>
        <div className="col-xs-12 col-sm-12 col-md-10 col-lg-7">
          <h2
            className={`${classes.title} second-title reveal-from-bottom-medium`}
            ref={containerRef}
            data-reveal-delay={50}
          >
            КАК ЭТО РАБОТАЕТ
          </h2>
          <div className={`${classes.list} row`}>
            {howItWorkItems.map((item, itemIndex) => (
              <div
                ref={el => ((itemsRef.current[itemIndex] as any) = el)}
                className={`${classes.list__wrap} col-xs-12 col-sm-6 col-md-6 col-lg-4 reveal-from-left`}
                key={itemIndex}
                data-reveal-delay={getNumber(itemIndex)}
              >
                <div className={classes.list__item}>
                  <div className={classes['list__item--count']}>
                    {itemIndex + 1}
                  </div>
                  <div className={classes['list__item--info']}>
                    <p className={classes['list__item--title']}>{item.title}</p>
                    <small>{item.descr}</small>
                  </div>
                </div>
              </div>
            ))}
          </div>
          <div
            ref={btnRef}
            className="reveal-from-left"
            data-reveal-delay={12600}
          >
            <Button onClick={() => setPartnerFormOpened(true)}>
              Стать партнером
            </Button>
          </div>
        </div>
      </div>
    </div>
  )
}
